import { useFileService } from './useFileService'
import { IFileResponse } from 'interfaces'
import { useEffect, useState } from 'react'

const useGetImgService = (imageId?: number) => {
  const { getUrlFile } = useFileService()
  const [imgFile, setImgFile] = useState<IFileResponse>()

  const handleGetImage = () => {
    if (imageId) {
      getUrlFile(imageId).then((res) => {
        if (res?._successfully) {
          setImgFile(res?.data)
        }
      })
    }
  }

  useEffect(() => {
    handleGetImage()
  }, [imageId])

  return { imgFile }
}
export default useGetImgService
